<script lang="ts" setup>
import { AppLogoDomain } from '@UI/Logos/AppLogoDomain'

defineOptions({
  name: 'ClassroomHeader',
})
</script>

<template>
  <header class="classroom-header">
    <AppLogoDomain />
  </header>
</template>

<style scoped lang="scss" src="@scss/components/Molecules/Classroom/ClassroomHeader.scss" />
